module.exports = __webpack_public_path__ + "static/img/file_java.5873b5b0.png";